import { render, staticRenderFns } from "./datatooltip.vue?vue&type=template&id=45c64b1e"
import script from "./datatooltip.ts?vue&type=script&lang=js&external"
export * from "./datatooltip.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c64b1e')) {
      api.createRecord('45c64b1e', component.options)
    } else {
      api.reload('45c64b1e', component.options)
    }
    module.hot.accept("./datatooltip.vue?vue&type=template&id=45c64b1e", function () {
      api.rerender('45c64b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/datatooltip.vue"
export default component.exports